import React from 'react';
import MuiAlert from '@mui/material/Alert';
import { ReactComponent as Search } from 'src/Images/icons/common/search.svg';
import { ReactComponent as Close } from 'src/Images/icons/common/close.svg';
import { ReactComponent as DeleteIcon } from 'src/Images/icons/common/delete.svg';
import AISuggestionSticker from 'src/components/VehicleTrackingDetails/VehicleTrackingContentForm/AISuggestionSticker';
import CustomMultiSelect from 'src/utils/CustomMultiSelect';
import { MdClose } from 'react-icons/md';
import { Col, Row } from 'react-bootstrap';

export default function VehicleTrackingContentFormMobile({
  toggleAddVehicleContentDrawer,
  logic,
}) {
  const {
    formData,
    setFormData,
    invalidFormSubmissionDetails,
    setInvalidFormSubmissionDetails,
    setPackTypeSearchTerms,
    packTypeSearchTerms,
    packTypeOptionsList,
    handleInputChange,
    themeColor,
    handleSubmit,
    disableSubmitButton,
    selectedProductionOption,
    setSelectedProductionOption,
    selectedPurchaseOrder,
    setSelectedPurchaseOrder,
    handleAddVehicleTrackingLineItem,
    vehicleTrackingLineItemsFormData,
    purchaseOrderDataOptions,
    productDataOptions,
    handleDeleteVehicleContentItem,
    showBlockedQuantityOverflowFlag,
    allowBlockedQuantityOverflow,
    handleAllowBlockedQuantityOverflowChange,
  } = logic;

  const renderVehicleTrackingLineItemFormCard = () => (
    <div className="div-flex-column rg-10 ">
      <div className="border-top" />
      {vehicleTrackingLineItemsFormData?.length > 0 &&
        vehicleTrackingLineItemsFormData
          ?.slice()
          .reverse()
          .map((itemObj) => {
            const itemData = itemObj.data;
            const instanceId = itemObj.id;
            const { lineItemId } = itemObj;

            const selectedPackTypeId = formData[instanceId]?.packTypeId;
            const selectedPackType = (
              packTypeOptionsList?.[lineItemId] || []
            ).find((pack) => pack.value === selectedPackTypeId);

            return (
              <div
                key={instanceId}
                className={`po-card-wrapper ${itemObj.suggestion ? 'suggested-card-style' : ''}`}
              >
                <AISuggestionSticker suggestion={itemObj.suggestion} />
                <Row
                  key={instanceId}
                  className={`div-flex-row div-space-between ${itemObj.suggestion ? '' : 'table-fixed-container'} py-2 px-2 top-padding gx-2`}
                >
                  <Col
                    xxl={2}
                    xl={2}
                    lg={2}
                    md={6}
                    sm={6}
                    xs={6}
                    className="form-input-container"
                  >
                    <div className="div-flex-column">
                      <span className="text-sm text-grey text-semi-bold">
                        PO Number
                      </span>
                      <span className="text-sm text-semi-bold">
                        {itemData?.po_number}
                      </span>
                    </div>
                  </Col>
                  <Col
                    xxl={2}
                    xl={2}
                    lg={2}
                    md={6}
                    sm={6}
                    xs={6}
                    className="form-input-container"
                  >
                    <div className="div-flex-column">
                      <span className="text-sm text-grey text-semi-bold">
                        Material Code
                      </span>
                      <span className="text-sm text-semi-bold">
                        {itemData?.material_code}
                      </span>
                    </div>
                  </Col>
                  <Col
                    xxl={2}
                    xl={2}
                    lg={2}
                    md={6}
                    sm={6}
                    xs={6}
                    className="form-input-container"
                  >
                    <div className="div-flex-column">
                      <span className="text-sm text-grey text-semi-bold">
                        Material Description
                      </span>
                      <span className="text-sm text-semi-bold wrap-content">
                        {itemData?.material_description}
                      </span>
                    </div>
                  </Col>
                  <Col
                    xxl={2}
                    xl={2}
                    lg={2}
                    md={6}
                    sm={6}
                    xs={6}
                    className="form-input-container"
                  >
                    <div className="div-flex-column">
                      <span className="text-sm text-grey text-semi-bold">
                        Plant
                      </span>
                      <span className="text-sm text-semi-bold">
                        {itemData?.plant}
                      </span>
                    </div>
                  </Col>
                  <Col
                    xxl={2}
                    xl={2}
                    lg={2}
                    md={6}
                    sm={6}
                    xs={6}
                    className="form-input-container"
                  >
                    <div className="div-flex-column">
                      <span className="text-sm text-grey text-semi-bold">
                        Rate
                      </span>
                      <span className="text-sm text-semi-bold">
                        {itemData?.rate}
                      </span>
                    </div>
                  </Col>
                  <Col
                    xxl={2}
                    xl={2}
                    lg={2}
                    md={6}
                    sm={6}
                    xs={6}
                    className="form-input-container"
                  >
                    <div className="div-flex-column">
                      <span className="text-sm text-grey text-semi-bold">
                        Open Quantity
                      </span>
                      <span className="text-sm text-semi-bold">
                        {itemData?.open_quantity}
                      </span>
                    </div>
                  </Col>
                  <Col
                    xxl={2}
                    xl={2}
                    lg={2}
                    md={6}
                    sm={6}
                    xs={6}
                    className="form-input-container"
                  >
                    <div className="div-flex-column">
                      <span className="text-sm text-grey text-semi-bold">
                        Pack Type *
                      </span>
                      <CustomMultiSelect
                        name="packTypeId"
                        isMulti={false}
                        className="multi-select-input-section"
                        onChange={(selectedOption) => {
                          setPackTypeSearchTerms((prev) => ({
                            ...prev,
                            [instanceId]: '',
                          }));
                          setFormData((prev) => ({
                            ...prev,
                            [instanceId]: {
                              ...prev[instanceId],
                              packTypeId: selectedOption?.value || null,
                            },
                          }));
                        }}
                        onInputChange={(inputValue, { action }) => {
                          if (action === 'input-change') {
                            setPackTypeSearchTerms((prev) => ({
                              ...prev,
                              [instanceId]: inputValue,
                            }));
                          }
                        }}
                        inputValue={packTypeSearchTerms[instanceId] || ''}
                        options={packTypeOptionsList[lineItemId] || []}
                        classNamePrefix="react-select"
                        placeholder="Search Pack Type"
                        value={packTypeOptionsList[lineItemId]?.find(
                          (option) =>
                            option.value === formData[instanceId]?.packTypeId,
                        )}
                        filterOption={() => true}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                  </Col>
                  <Col
                    xxl={2}
                    xl={2}
                    lg={2}
                    md={6}
                    sm={6}
                    xs={6}
                    className="form-input-container"
                  >
                    <div className="div-flex-column">
                      <span className="text-sm text-grey text-semi-bold">
                        Pack Type Weight
                      </span>
                      <span className="text-sm text-semi-bold">
                        {selectedPackType?.packTypeWeight || '-'}
                      </span>
                    </div>
                  </Col>
                  <Col
                    xxl={2}
                    xl={2}
                    lg={2}
                    md={6}
                    sm={6}
                    xs={6}
                    className="form-input-container"
                  >
                    <div className="div-flex-column">
                      <span className="text-sm text-grey text-semi-bold">
                        Pack Quantity *
                      </span>
                      <input
                        className="form-input-section"
                        type="number"
                        min="0"
                        name="packTypeQuantity"
                        value={formData[instanceId]?.packTypeQuantity || ''}
                        onChange={(e) => handleInputChange(e, instanceId)}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </Col>
                  <Col
                    xxl={2}
                    xl={2}
                    lg={2}
                    md={6}
                    sm={6}
                    xs={6}
                    className="form-input-container"
                  >
                    <div className="div-flex-column">
                      <span className="text-sm text-grey text-semi-bold">
                        Receiving Quantity *
                      </span>
                      <input
                        className="form-input-section"
                        type="number"
                        min="0"
                        name="receivingQuantity"
                        value={formData[instanceId]?.receivingQuantity || ''}
                        onChange={(e) => handleInputChange(e, instanceId)}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                  </Col>
                  <Col
                    xxl={2}
                    xl={2}
                    lg={2}
                    md={6}
                    sm={6}
                    xs={6}
                    className="form-input-container"
                  >
                    <div className="div-flex-column">
                      <span className="text-sm text-grey text-semi-bold">
                        Invoice Number *
                      </span>
                      <input
                        className="form-input-section"
                        type="text"
                        name="invoiceNumber"
                        value={formData[instanceId]?.invoiceNumber || ''}
                        onChange={(e) => handleInputChange(e, instanceId)}
                      />
                    </div>
                  </Col>
                  <Col
                    xxl={2}
                    xl={2}
                    lg={2}
                    md={6}
                    sm={6}
                    xs={6}
                    className="form-input-container"
                  >
                    <div className="div-flex-column">
                      <span className="text-sm text-grey text-semi-bold">
                        Eway Bill *
                      </span>
                      <input
                        className="form-input-section"
                        type="text"
                        name="ewayBillNumber"
                        value={formData[instanceId]?.ewayBillNumber || ''}
                        onChange={(e) => handleInputChange(e, instanceId)}
                      />
                    </div>
                  </Col>
                </Row>
                <div className="delete-icon-wrapper">
                  <DeleteIcon
                    className="icon-size-xxl"
                    color="#9F9F9F"
                    onClick={() => handleDeleteVehicleContentItem(instanceId)}
                  />
                </div>
              </div>
            );
          })}
    </div>
  );

  return (
    <div className="page-layout gap-2">
      {invalidFormSubmissionDetails.isInvalid && (
        <MuiAlert
          onClose={() =>
            setInvalidFormSubmissionDetails({ isInvalid: false, message: '' })
          }
          severity="error"
          elevation={6}
          variant="filled"
        >
          {invalidFormSubmissionDetails.message}
        </MuiAlert>
      )}
      <div className="div-flex-row div-space-between div-align-center border-bottom drawer-section-padding">
        <div className="div-space-between slider-padding">
          <span className="text-xxl text-bold">Add Vehicle Content</span>
        </div>
        <button
          className="icon-btn-none"
          onClick={() => toggleAddVehicleContentDrawer(false)}
          aria-label="Close drawer"
        >
          <MdClose size="24px" />
        </button>
      </div>

      <div
        className={`main-vehicle-tracking-detail-form-container theme-scrollable-container-${themeColor}`}
      >
        <div className="form-line-item-container top-padding">
          <Row>
            <div>
              {showBlockedQuantityOverflowFlag && (
                <div className="vehicle-tracking-detail-tab-title-section mb-3">
                  <div className="timeline-header move-stage-section-container rg-10">
                    <div className="div-flex-row div-align-center cg-5">
                      <input
                        type="checkbox"
                        id="allowBlockedQuantityOverflow"
                        checked={allowBlockedQuantityOverflow}
                        onChange={(e) =>
                          handleAllowBlockedQuantityOverflowChange(
                            e.target.checked,
                          )
                        }
                      />
                      <label
                        htmlFor="allowBlockedQuantityOverflow"
                        className="text-sm text-semi-bold"
                      >
                        Allow Blocked Quantity Overflow
                      </label>
                    </div>

                    {allowBlockedQuantityOverflow && (
                      <div
                        className="div-flex-column rg-10"
                        style={{ marginTop: '10px' }}
                      >
                        <span className="text-sm">
                          ⚠️ Changing this toggle will reset all receiving
                          quantities to their original values.
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
              <div className="div-flex-column rg-5">
                <div className="text-sm text-semi-bold">PO Number</div>
                <div className="input-wrapper">
                  <CustomMultiSelect
                    name="purchaseOrderId"
                    isMulti={false}
                    className="multi-select-input-section"
                    onChange={(selectedOption) => {
                      setSelectedPurchaseOrder({
                        name: selectedOption.label,
                        value: selectedOption?.value || null,
                      });
                    }}
                    options={purchaseOrderDataOptions}
                    classNamePrefix="react-select"
                    placeholder="Search PO"
                    value={
                      purchaseOrderDataOptions.find(
                        (option) =>
                          option.value === selectedPurchaseOrder?.value,
                      ) || null
                    }
                    filterOption={() => true}
                  />
                  <span className="form-input-section-icon">
                    <Search className="icon-size-sm" color="#9F9F9F" />
                  </span>
                </div>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6}>
              <div className="div-flex-column rg-5">
                <div className="text-sm text-semi-bold">Product</div>
                <div className="input-wrapper">
                  <CustomMultiSelect
                    name="materialCodeId"
                    isMulti={false}
                    className="multi-select-input-section"
                    onChange={(selectedOption) => {
                      setSelectedProductionOption({
                        name: selectedOption.label,
                        value: selectedOption?.value || null,
                      });
                    }}
                    options={productDataOptions}
                    classNamePrefix="react-select"
                    placeholder="Search Material"
                    value={
                      productDataOptions.find(
                        (option) =>
                          option.value === selectedProductionOption?.value,
                      ) || null
                    }
                    filterOption={() => true}
                  />
                  {selectedProductionOption?.value ? (
                    <span className="form-input-section-icon">
                      <Close
                        type="button"
                        onClick={() => {
                          setSelectedProductionOption({
                            name: '',
                            value: null,
                          });
                        }}
                        color="#9F9F9F"
                        className="icon-size-xs"
                      />
                    </span>
                  ) : (
                    <span className="form-input-section-icon">
                      <Search className="icon-size-sm" color="#9F9F9F" />
                    </span>
                  )}
                </div>
              </div>
            </Col>
            <Col xxl={1} xl={1} lg={1} md={6} sm={12} xs={12}>
              <div className="div-flex-column">
                <div className="div-flex-row div-flex-end padding-top-8">
                  <div className="text-sm text-semi-bold text-white">.</div>
                  <button
                    type="button"
                    className={`vehicle-tracking-detail-move-stage-btn theme-background-${themeColor}`}
                    onClick={handleAddVehicleTrackingLineItem}
                  >
                    <span className="text-md">Add</span>
                  </button>
                </div>
              </div>
            </Col>
          </Row>
          {renderVehicleTrackingLineItemFormCard()}
        </div>
      </div>

      <div className="drawer-section-padding ">
        <div className="line-item-container-padding">
          <div className="div-space-between div-align-center ">
            <div></div>
            <button
              type="button"
              className={
                disableSubmitButton
                  ? 'vehicle-tracking-detail-move-stage-btn vehicle-tracking-detail-move-stage-btn-disable'
                  : `vehicle-tracking-detail-move-stage-btn theme-background-${themeColor}`
              }
              onClick={handleSubmit}
              disabled={disableSubmitButton}
            >
              <span className="text-md">Submit</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
